import React from "react";
import { motion } from "framer-motion";
import CTAButton from "./CTAButton";
const steps = [
  { n: "01", t: "Consultoria especializada", d: "Entendemos seus objetivos, renda e perfil. Sem pitch, sem pressão — apenas análise." },
  { n: "02", t: "Estratégia sob medida", d: "Montamos seu projeto patrimonial ideal: prazo, alavancagem, tributação e liquidez." },
  { n: "03", t: "Consórcio formatado", d: "Parcelas otimizadas e estratégias de contemplação acelerada para o seu caso." },
  { n: "04", t: "Contemplação & imóvel", d: "Escolhemos juntos o ativo com maior rentabilidade e valorização." },
  { n: "05", t: "Renda & patrimônio", d: "O imóvel gera renda mensal e valoriza enquanto o consórcio é pago pelo aluguel." },
];
export default function HowItWorks() {
  return (
    <section id="como-funciona" className="py-24 lg:py-32" data-testid="how-it-works">
      <div className="container">
        <div className="max-w-3xl mb-16">
          <div className="eyebrow mb-4"><span className="kicker-line" />Processo</div>
          <h2 className="text-4xl md:text-5xl font-display font-light">Do primeiro contato à <span className="italic text-gold-gradient">renda passiva</span>.</h2>
          <p className="text-muted-foreground mt-6 max-w-xl">Um método em cinco movimentos. Estruturado, transparente e construído para durar.</p>
        </div>
        <div className="relative">
          <div className="absolute left-0 right-0 top-[54px] hidden lg:block hairline" />
          <div className="grid gap-10 lg:grid-cols-5 lg:gap-6">
            {steps.map((s, i) => (
              <motion.div key={i} initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: i * 0.1 }} className="relative">
                <div className="flex lg:block items-start gap-6">
                  <div className="relative z-10 w-14 h-14 rounded-full bg-background border border-primary/40 flex items-center justify-center font-mono text-primary text-sm shadow-gold">{s.n}</div>
                  <div className="lg:mt-6">
                    <h3 className="font-display text-xl mb-2">{s.t}</h3>
                    <p className="text-sm text-muted-foreground leading-relaxed">{s.d}</p>
                  </div>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
        <CTAButton centered />
      </div>
    </section>
  );
}
